import React from 'react'
import { Route } from 'react-router-dom'
import PageContainer from '@layout/PageContainer'
import AppSidebar from '@layout/AppSidebar'
import { ROOT_NAV, findBreadcrumbs } from '@data/nav'

function findRootByHref(href) {
  if (!href) return null
  const norm = href.split(/[?#]/)[0]
  let matched = null
  let longest = 0

  ROOT_NAV.forEach(root => {
    if (root.href && norm.startsWith(root.href)) {
      if (root.href.length > longest) {
        matched = root
        longest = root.href.length
      }
    }
    root.children?.forEach(child => {
      if (child.href && norm.startsWith(child.href)) {
        if (child.href.length > longest) {
          matched = root
          longest = child.href.length
        }
      }
    })
  })

  return matched
}

function normalizePath(path) {
  return path.replace(/\/:[^/]+/g, '');
}

export default function ContainerRoute(path, element, options = {}) {
  // 1) canonical path 기준으로 root/crumbs 계산
  const normalizedPath = normalizePath(path);

  const root = findRootByHref(normalizedPath);
  const crumbs = findBreadcrumbs(normalizedPath) || [];

  const currentCrumb =
    [...crumbs].reverse().find((c) => !c.hidden && !c.subMain) || null;

  const title =
    options.title ??
    currentCrumb?.label ??
    root?.label ??
    'OpenVLab';

  const hideHeader =
    options.hideHeader ??
    (normalizedPath === '/' || currentCrumb?.subMain);

  const sidebarItems = root?.children ?? [];
  if (root) sidebarItems.__rootLabel = root.label;

  const showSidebar =
    options.showSidebar ??
    (sidebarItems.length > 0 && normalizedPath !== '/');

  // 2) 영어용 path 생성
  const enPath =
    path === '/'
      ? '/en'               // 루트는 / → /en
      : path.startsWith('/en')
        ? path              // 혹시 이미 /en 넘기면 그대로
        : `/en${path}`;     // 나머지는 /en + canonical

  // 3) 공통 element 한 번 정의
  const pageElement = (
    <PageContainer
      title={title}
      hideHeader={hideHeader}
      sidebar={showSidebar ? <AppSidebar items={sidebarItems} /> : null}
      contentMinWidth={options.contentMinWidth}
      contentMaxWidth={options.contentMaxWidth}
      items={options.items}
    >
      {element}
    </PageContainer>
  );

  // 4) 한글 Route + 영어 Route 둘 다 리턴
  return (
    <>
      <Route
        key={path}
        path={path}
        element={pageElement}
      />
      <Route
        key={enPath}
        path={enPath}
        element={pageElement}
      />
    </>
  )
}
